import { useEffect, useState } from 'react'
import { Loading } from 'notiflix'
import { Report } from 'notiflix/build/notiflix-report-aio'
import api from '../helpers/apiRequester'
import { getLoginUrl } from '../helpers/authConfig'
import Sidebar from '../components/layout/sidebar/sidebar'
import { MainView } from '../components/layout/main'
import { ViewTitle } from '../components/reusable'
import { StatsView } from '../components/views/statsView'
import Modal from '../components/reusable/modal'
import { ViewChartDataModalContent } from '../components/modalContent/viewChartDataContent'

function AdlILStats() {
    const [dataReady, setDataReady] = useState(false)
    const [loading, setLoading] = useState(false)
    const [overviewData, setOverviewData] = useState<any>()
    const [modalChartData, setModalChartData] = useState<any>()
    const [modalState, setModalState] = useState(false)
    const [modalTitle, setModalTitle] = useState('')
    const [modalDate, setModalDate] = useState('')
    const [showChart, setShowChart] = useState<Array<string>>(['IL Progress', 'PCP Remarketing'])

    useEffect(() => {
        if (modalChartData != null) {
            setModalState(true)
        }
    }, [modalChartData])

    useEffect(() => {
        if (!dataReady && !loading) {
            setLoading(true)
            getData()
        }
    }, [dataReady, loading])

    const getData = async () => {
        Loading.circle('Loading...')
        try {
            const apiResponse = await api({
                url: '/adl-il-stats',
            })
            const data = apiResponse.data
            console.log('ADL API Response:', data)

            if (data.success) {
                const statsData = {
                    stats: [
                        {
                            title: 'IL Progress',
                            values: [
                                { Submitted: data.numberOfClients || 0 },
                                { Signed: data.signedClients || 0 },
                                { Complete: data.completeClients || 0 },
                            ],
                        },
                        {
                            title: 'PCP Remarketing',
                            values: [{ 'Total Remarketed': data.remarketedAdlClientsCount || 0 }],
                        },
                    ],
                    chartData: {
                        ...(data.chartData || {
                            'IL Progress': {
                                labels: [],
                                datasets: [],
                            },
                        }),
                        'PCP Remarketing': data.remarketedAdlChartData?.['PCP Remarketing'] || {
                            labels: [],
                            datasets: [],
                        },
                    },
                    group: 'adlIL',
                    remarketedGroup: 'remarketedAdl',
                }
                setOverviewData(statsData)
            } else {
                Report.failure('Error', data.message || 'Failed to load ADL IL stats', 'Okay')
                const emptyData = {
                    stats: [
                        {
                            title: 'IL Progress',
                            values: [{ Submitted: 0 }, { Signed: 0 }, { Complete: 0 }],
                        },
                        {
                            title: 'PCP Remarketing',
                            values: [{ 'Total Remarketed': 0 }],
                        },
                    ],
                    chartData: {
                        'IL Progress': {
                            labels: [],
                            datasets: [],
                        },
                        'PCP Remarketing': {
                            labels: [],
                            datasets: [],
                        },
                    },
                    group: 'adlIL',
                }
                setOverviewData(emptyData)
            }

            setDataReady(true)
            Loading.remove()
        } catch (error: any) {
            console.log(error)
            Loading.remove()
            if (error?.response?.status == 401) {
                Report.failure('Session Timed Out', 'Please log in again to continue.', 'Okay', () => {
                    window.location.href = getLoginUrl()
                })
            } else {
                Report.failure('Error', 'Failed to load ADL IL stats. Please try again.', 'Okay')
                const emptyData = {
                    stats: [
                        {
                            title: 'IL Progress',
                            values: [{ Submitted: 0 }, { Signed: 0 }, { Complete: 0 }],
                        },
                        {
                            title: 'PCP Remarketing',
                            values: [{ 'Total Remarketed': 0 }],
                        },
                    ],
                    chartData: {
                        'IL Progress': {
                            labels: [],
                            datasets: [],
                        },
                        'PCP Remarketing': {
                            labels: [],
                            datasets: [],
                        },
                    },
                    group: 'adlIL',
                }
                setOverviewData(emptyData)
                setDataReady(true)
            }
        }
    }

    const prepChartData = (data: any) => {
        setModalChartData(data.dataResults)
        setModalTitle(data.title)
        setModalDate(data.date)
    }

    const toggleModal = () => {
        setModalState(false)
    }

    return (
        <div className="home">
            <Sidebar />
            <MainView>
                <ViewTitle text={'ADL IL Stats'} />
                <div>
                    {dataReady ? (
                        <StatsView
                            stats={overviewData.stats}
                            chartData={overviewData?.chartData}
                            dataGroup={overviewData.group}
                            remarketedGroup={overviewData.remarketedGroup}
                            handleDataModal={prepChartData}
                            initialShowChart={showChart}
                        />
                    ) : (
                        <></>
                    )}
                </div>
            </MainView>
            <Modal modalState={modalState} previewModalAction={toggleModal}>
                <ViewChartDataModalContent
                    chartData={modalChartData}
                    closeModal={toggleModal}
                    chartTitle={modalTitle}
                    chartDate={modalDate}
                />
            </Modal>
        </div>
    )
}

export default AdlILStats
